var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorsProfileImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 213,
    height: 213,
    viewBox: "0 0 213 213",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doctors-profile-image",
    transform: "translate(-360 -299)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Box",
    width: 213,
    height: 213,
    rx: 10,
    transform: "translate(360 299)",
    fill: "#eff7ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "doctor-icon",
    d: "M118.21,79.783a16.869,16.869,0,1,0-22.135,16.2A24.377,24.377,0,0,1,48.33,89.263V82.834a8.471,8.471,0,0,0,1.526-1.157L77.219,54.421l.827-.84a25.225,25.225,0,0,0-4.868-39.77,12.472,12.472,0,0,0-24.921.921A12.592,12.592,0,0,0,60.762,27.383a12.4,12.4,0,0,0,9.861-4.958,16.73,16.73,0,0,1,1.359,25.1L44.057,75.356,16.934,48.34l-.874-.849a16.808,16.808,0,0,1,0-23.9,17.208,17.208,0,0,1,1.449-1.234A12.4,12.4,0,0,0,27.361,27.3a12.652,12.652,0,0,0,0-25.3,12.544,12.544,0,0,0-12.42,11.772,25.641,25.641,0,0,0-4.911,3.737,25.371,25.371,0,0,0,.026,36.1L38.272,81.7a8.39,8.39,0,0,0,1.487,1.144v6.424a32.942,32.942,0,0,0,65.016,7.3A17.109,17.109,0,0,0,118.21,79.783Z",
    transform: "translate(406.5 344)",
    fill: "#7aba56"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorsProfileImage);
export default __webpack_public_path__ + "static/media/doctors-profile-image.e1ea69d1cc96873c67b73b576c1af82d.svg";
export { ForwardRef as ReactComponent };